import { Component, OnDestroy } from '@angular/core';

// --- Facades ---
import { AppearanceFacade } from '@facades/appearance.facade';
import { StoresFacade } from '@facades/stores.facade';

// --- Interfaces ---
import type { IStore } from '@interfaces/store';

@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnDestroy {
	address!: IStore['displayedAddress'];
	corporateName!: IStore['corporateName'];

	constructor(
		private appearanceFacade: AppearanceFacade,
		private storeFacade: StoresFacade
	) {}

	ngOnDestroy() {
		this.storeFacade.currentStore = null;
	}

	get appearance() {
		const { logo, useTheme } = this.appearanceFacade;
		return { logo, useTheme };
	}

	get currentStore() {
		return this.storeFacade.currentStore;
	}
}
